export const TABLE_CONST = {
  ASC: 'ASC',
  DESC: 'DESC',
  DIRECTION: {
    ASC: 'ascending',
    DESC: 'descending',
  },
  ALIGN: {
    center: 'center',
    left: 'flex-start',
    right: 'flex-end',
  },
}
